import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M2.47 2.472a.75.75 0 0 1 1.06 0l1.011 1.011a2.87 2.87 0 0 1 1.78-.903 49.3 49.3 0 0 1 11.359 0c1.497.174 2.57 1.46 2.57 2.93v13.682l1.28 1.28a.75.75 0 1 1-1.06 1.06l-18-18a.75.75 0 0 1 0-1.06m16.28 15.22V5.509c0-.746-.54-1.358-1.243-1.44a47.8 47.8 0 0 0-11.014 0 1.38 1.38 0 0 0-.89.476z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M4.5 7.995a.75.75 0 0 1 .75.75v11.044l6.415-3.208a.75.75 0 0 1 .67 0l2.016 1.008a.75.75 0 0 1-.671 1.342L12 18.09l-7.165 3.582a.75.75 0 0 1-1.085-.67V8.744a.75.75 0 0 1 .75-.75"
    }, null, -1)
  ])))
}
export default { render: render }